// services/cache/productCache.ts

import { getRedisClient } from "../../client";
import { getKey } from "../../utils/redisKeys";
import type { KeyOptions } from "../../utils/redisKeys";

const prefix = "product";

export async function setProduct(id: string, value: any, ttlInSec?: number) {
  const client = getRedisClient();
  const key = getKey({ prefix, id });
  const stringified = JSON.stringify(value);

  if (ttlInSec) {
    await client.set(key, stringified, { EX: ttlInSec });
  } else {
    await client.set(key, stringified);
  }
}

export async function getProduct(id: string) {
  const client = getRedisClient();
  const key = getKey({ prefix, id });
  const data = await client.get(key);
  return data ? JSON.parse(data) : null;
}

export async function deleteProduct(id: string) {
  const client = getRedisClient();
  const key = getKey({ prefix, id });
  await client.del(key);
}

export async function getProductsBulk(ids: string[]) {
  const client = getRedisClient();
  const keys = ids.map((id) => getKey({ prefix, id }));
  const results = await client.mGet(keys);
  return results.map((data) => (data ? JSON.parse(data) : null));
}